import { render } from "./UploadImages.vue?vue&type=template&id=469d38dd&scoped=true"
import script from "./UploadImages.vue?vue&type=script&lang=js"
export * from "./UploadImages.vue?vue&type=script&lang=js"

import "./UploadImages.vue?vue&type=style&index=0&id=469d38dd&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469d38dd"]])

export default __exports__